import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { RouterModule } from '@angular/router';
import { NotAuthAndCheckUserIdGuard } from '@cutting/main/shared/guards/not-auth-and-check-user-id.guard';
import { FuseSharedModule } from '@fuse/shared.module';

import { TokenManagerService } from '../token-manager/token-manager.service';
import { FuseLoginComponent } from './login.component';
import { LoginService } from './login.service';

const routes = [
  {
    path: 'client/auth/login',
    component: FuseLoginComponent,
    canActivate: [NotAuthAndCheckUserIdGuard],
  },
];

@NgModule({
  declarations: [FuseLoginComponent],
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatSnackBarModule,
    MatMenuModule,
    MatProgressSpinnerModule,

    FuseSharedModule,
    RouterModule.forChild(routes),
  ],
  providers: [TokenManagerService, LoginService, NotAuthAndCheckUserIdGuard],
})
export class LoginModule {}
